import { jsx as c, Fragment as l } from "react/jsx-runtime";
import { useEffect as n } from "react";
import { r as i } from "../../index-DC7FmJPK.mjs";
import '../../assets/Overlay.css';const d = "_overlay_itsaf_1", v = "_fade_itsaf_1", m = "_reveal_itsaf_1", u = "_hide_itsaf_1", y = {
  overlay: d,
  fade: v,
  reveal: m,
  hide: u
};
function h({ appendToElement: r, state: a = "entering" }) {
  (() => {
    if (!document.querySelector("#overlay")) {
      const t = document.createElement("div");
      t.setAttribute("id", "overlay"), t.setAttribute("class", `${y.overlay} overlay`), t.setAttribute("data-state", "entering"), r !== null ? r.append(t) : document.body.appendChild(t);
    }
  })();
  const o = setInterval(() => {
    const e = document.querySelector("#overlay");
    if (e) {
      const t = () => {
        const s = new CustomEvent("scripps:overlay:closed");
        document.dispatchEvent(s), e.setAttribute("data-state", "exiting"), setTimeout(() => {
          e.remove();
        }, 200);
      };
      clearInterval(o), e.addEventListener("click", t);
    }
  });
  return n(() => {
    var e;
    (e = document.querySelector("#overlay")) == null || e.setAttribute("data-state", a);
  }, [a]), i.createPortal(
    /* @__PURE__ */ c(l, {}),
    document.getElementById("overlay")
  );
}
export {
  h as Overlay,
  h as default
};
